import { Candle } from '@shared/types';

/**
 * Average True Range (ATR)
 */
export class ATR {
  private period: number;
  private trueRanges: number[] = [];
  private atr: number = 0;
  private prevClose: number | null = null;

  constructor(period: number = 14) {
    this.period = period;
  }

  update(candle: Candle): number {
    // Calculate True Range
    let tr: number;

    if (this.prevClose === null) {
      // First candle, TR = high - low
      tr = candle.high - candle.low;
    } else {
      // TR = max(high - low, abs(high - prevClose), abs(low - prevClose))
      tr = Math.max(
        candle.high - candle.low,
        Math.abs(candle.high - this.prevClose),
        Math.abs(candle.low - this.prevClose)
      );
    }

    // Add to rolling window
    this.trueRanges.push(tr);

    // Keep only the last 'period' values for Simple Moving Average
    if (this.trueRanges.length > this.period) {
      this.trueRanges.shift();
    }

    // Calculate Simple Moving Average of True Ranges
    if (this.trueRanges.length === this.period) {
      this.atr = this.trueRanges.reduce((a, b) => a + b, 0) / this.period;
    }

    this.prevClose = candle.close;
    return this.atr;
  }

  getValue(): number {
    return this.atr;
  }

  isReady(): boolean {
    return this.trueRanges.length === this.period;
  }

  reset(): void {
    this.trueRanges = [];
    this.atr = 0;
    this.prevClose = null;
  }
}
